import { render, staticRenderFns } from "./company_info.vue?vue&type=template&id=2fb6f03c&scoped=true"
import script from "./company_info.vue?vue&type=script&lang=js"
export * from "./company_info.vue?vue&type=script&lang=js"
import style0 from "./company_info.vue?vue&type=style&index=0&id=2fb6f03c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb6f03c",
  null
  
)

export default component.exports